<button mat-icon-button class="dialog-close-btn" (click)="onClose()">
  <mat-icon>close</mat-icon>
</button>

<h2 mat-dialog-title class="modal-title">Update Client</h2>

<form [formGroup]="updateForm" (ngSubmit)="onSubmit()">

  <mat-dialog-content class="form-content">

    <!-- Row 1: Client Name and Fin Number -->
    <div class="form-row">
      <div class="form-item">
        <mat-form-field appearance="outline" class="form-field full-width">
          <mat-label>Client Name</mat-label>
          <input matInput formControlName="clientName" />
          <mat-error *ngIf="f['clientName'].hasError('required')">
            This field is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-item">
        <mat-form-field appearance="outline" class="form-field full-width">
          <mat-label>Fin Number</mat-label>
          <input matInput formControlName="finNumber" maxlength="6" />
          <mat-error *ngIf="f['finNumber'].hasError('required')">
            This field is required
          </mat-error>
          <mat-error *ngIf="f['finNumber'].hasError('pattern') || f['finNumber'].hasError('minlength') || f['finNumber'].hasError('maxlength')">
            Financial number must be 6 alphanumeric characters
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <!-- Row 2: Company Code (read-only) -->
    <div class="form-row">
      <div class="form-item">
        <mat-form-field appearance="outline" class="form-field full-width">
          <mat-label>Company Code</mat-label>
          <input matInput formControlName="companyCode" />
        </mat-form-field>
      </div>
    </div>

    <!-- Row 3: Registration Date and Active Employees -->
    <div class="form-row">
      <div class="form-item">
        <app-data-picker
          [label]="'Registration Date'"
          [form]="updateForm"
          controlName="registrationDate"
          [maxDate]="today">
        </app-data-picker>
      </div>
      <div class="form-item">
        <mat-form-field appearance="outline" class="form-field full-width">
          <mat-label>Active Employees</mat-label>
          <input matInput formControlName="activeEmployees" type="text" inputmode="numeric" />
          <mat-error *ngIf="f['activeEmployees'].hasError('required')">
            This field is required
          </mat-error>
          <mat-error *ngIf="f['activeEmployees'].hasError('pattern')">
            Please enter a valid number
          </mat-error>
          <mat-error *ngIf="f['activeEmployees'].hasError('min')">
            Minimum value is 1
          </mat-error>
          <mat-error *ngIf="f['activeEmployees'].hasError('max')">
            License Limit cannot exceed 1,000,000
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <!-- Row 4: Branch -->
    <div class="form-row">
      <div class="form-item">
        <app-input-dropdown
          [label]="'Branch'"
          [formGroup]="updateForm"
          controlName="branch"
          [options]="branches"
          [disable]="true"
          (selectionChange)="onCategorySelect($event)">
        </app-input-dropdown>
      </div>

      <!-- Condition field (only visible if branch is 'OTHER') -->
      <div class="form-item" *ngIf="isUpdateBranchOther()">
        <app-input-dropdown
          [label]="'Client Specific Branch'"
          [formGroup]="updateForm"
          controlName="condition"
          [options]="conditionOptions"
          [disable]="true"
          (selectionChange)="onConditionSelect($event)">
        </app-input-dropdown>
      </div>
    </div>

    <!-- Row 5: Override Company Theme -->
    <div class="form-row">
      <div class="form-item">
        <app-checkboxes
          label="Override Theme"
          [checkboxes]="overrideThemeOptions"
          (selectionChange)="onOverrideThemeChange($event)">
        </app-checkboxes>
      </div>
      <!-- Theme Name (visible only if override is enabled) -->
      <div class="form-item" *ngIf="updateForm.get('companyTheme')?.value">
        <app-input-dropdown
          [label]="'Theme Name'"
          [formGroup]="updateForm"
          controlName="themeName"
          [options]="themeNameOptions"
          (selectionChange)="onThemeSelect($event)">
        </app-input-dropdown>
      </div>
      <!-- Read-only Theme Name (visible when override is disabled) -->
      <div class="form-item" *ngIf="!updateForm.get('companyTheme')?.value">
        <mat-form-field appearance="outline" class="form-field full-width">
          <mat-label>Theme Name</mat-label>
          <input matInput formControlName="themeName" readonly />
        </mat-form-field>
      </div>
    </div>

    <!-- Row 6: Platform Enabled -->
    <div class="form-row">
      <div class="form-item">
        <app-checkboxes
          label="Platform Enabled"
          [checkboxes]="platformEnabledOptions"
          (selectionChange)="onPlatformEnabledChange($event)">
        </app-checkboxes>
      </div>
    </div>

  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions">
    <app-form-actions-buttons [buttons]="submitButtons"></app-form-actions-buttons>
  </mat-dialog-actions>
</form>
